import React from "react";
import { nanoid } from "@reduxjs/toolkit";
import { UrlLink } from "./UrlLink.styled";

const urlRegex = /(https?:\/\/[^\s]+)/g;

const UrlifyLink = ({ text }: { text: string }) => {
    let url = text?.split(urlRegex).map((part) => {
        if (part.match(urlRegex)) {
            return (
                <UrlLink
                    key={nanoid()}
                    href={part}
                    target="_blank"
                    rel="noreferrer"
                >
                    {part}
                </UrlLink>
            );
        }
        return part;
    });
    return <span>{url}</span>;
};

export default UrlifyLink;
